const clearMediaElement = (audioEl) => {
  if (!audioEl) return;

  audioEl.oncanplay = null;
  audioEl.onended = null;
  try {
    audioEl.pause();
  } catch (error) {
    // Some test / detached audio nodes throw on pause.
  }
  try {
    audioEl.currentTime = 0;
  } catch (error) {
    // Setting currentTime can throw before metadata is ready.
  }
  audioEl.removeAttribute("src");
  audioEl.src = "";
  try {
    audioEl.load();
  } catch (error) {
    // jsdom and some browsers throw when load() is called without a source.
  }
};

export const attachGlobalAlertAudio = (audioEl, { fallbackPlay } = {}) => {
  let playGeneration = 0;

  const stop = () => {
    playGeneration += 1;
    clearMediaElement(audioEl);
  };

  const play = (src, volume = 1) => {
    if (!audioEl || !src) return;

    const generation = playGeneration + 1;
    playGeneration = generation;
    audioEl.oncanplay = null;
    audioEl.onended = null;
    audioEl.volume = volume;

    const tryPlay = () => {
      if (generation !== playGeneration) return;
      audioEl.oncanplay = null;
      try {
        audioEl.currentTime = 0;
      } catch (error) {
        // Ignore seek errors before the element is ready.
      }

      const playPromise = audioEl.play();
      if (playPromise && typeof playPromise.then === "function") {
        playPromise.catch((error) => {
          if (generation !== playGeneration) return;
          console.warn("❌ <audio>.play() failed:", error);
          if (typeof fallbackPlay === "function") {
            fallbackPlay(src, volume);
          }
        });
      }
    };

    audioEl.onended = () => {
      if (generation !== playGeneration) return;
      stop();
    };

    audioEl.src = src;
    if (audioEl.readyState >= 2) {
      tryPlay();
    } else {
      audioEl.oncanplay = tryPlay;
    }
  };

  const handleLifecyclePause = () => {
    stop();
  };

  const handleVisibilityChange = () => {
    if (typeof document !== "undefined" && document.hidden) {
      stop();
    }
  };

  if (typeof document !== "undefined") {
    document.addEventListener("visibilitychange", handleVisibilityChange);
    document.addEventListener("freeze", handleLifecyclePause);
  }
  if (typeof window !== "undefined") {
    window.addEventListener("pagehide", handleLifecyclePause);
  }

  const dispose = () => {
    stop();
    if (typeof document !== "undefined") {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      document.removeEventListener("freeze", handleLifecyclePause);
    }
    if (typeof window !== "undefined") {
      window.removeEventListener("pagehide", handleLifecyclePause);
    }
  };

  return {
    play,
    stop,
    dispose,
  };
};
